<span class="fi fi-{{flag}}" [class.fis]="isSquare" style="font-size: {{size}}%;"></span>